import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function InviteAccept() {
  const { token } = useParams();
  const nav = useNavigate();
  const { setSession } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(apiErr(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Heslo musí mít alespoň 8 znaků");
    if (password !== confirm) return toast.error("Hesla se neshodují");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/invite/accept", { token, password });
      setSession(data.token, data.user);
      toast.success("Účet aktivován");
      nav("/admin");
    } catch (e2) {
      toast.error(apiErr(e2));
    } finally {
      setLoading(false);
    }
  };

  if (err) return <div className="min-h-screen grid place-items-center p-8 text-center text-red-600">{err}</div>;
  if (!info) return <div className="min-h-screen grid place-items-center text-slate-500">Načítání…</div>;

  return (
    <div className="min-h-screen grid place-items-center p-8 bg-[#F8FAFC]">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6 bg-white p-8 rounded-xl border shadow-sm" data-testid="invite-form">
        <div className="okenfix-brand text-2xl font-extrabold" style={{ color: "#0A2540" }}>OKENFIX</div>
        <div>
          <h2 className="text-xl font-bold text-[#0A2540]">Nastavení hesla předsedy</h2>
          <p className="text-slate-500 mt-1">{info.email}</p>
        </div>
        <div className="space-y-2">
          <Label>Nové heslo</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" data-testid="invite-password" />
        </div>
        <div className="space-y-2">
          <Label>Potvrzení hesla</Label>
          <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-12" data-testid="invite-confirm" />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-12" style={{ background: "#0A2540" }} data-testid="invite-submit">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Aktivovat účet
        </Button>
      </form>
    </div>
  );
}
